<template>
  <div class="card">
        <h5>{{title}}</h5>
        <hr>
        
        <div class="container p-0 m-0">
					<div class="row mb-2">
						<BasicTextInput 
							class="col" 
							placeholder="" 
							label="MFID" 
							v-model="product.MfgCode"/>

						<BasicTextInput 
							class="col"
							placeholder="" 
							label="Part #" 
							v-model="product.PartNumber"/>
					</div>

					<div class="row mb-2">
						<BasicTextInput
							class="col"
							placeholder=""
							label="RefCode"
							v-model="product.ReferenceCode"/>

						<BasicTextInput
							class="col"
							placeholder=""
							label="Stock Code"
							v-model="product.StockCode"/>
					</div>

					<div class="row mb-2">
						<BasicTextInput
							class="col"
							placeholder=""
							label="Description"
							v-model="product.Description"/>
					</div>

          <div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Retail Price" 
              v-model="product.Retail"/>

						<CurrencyInput 
              class="col" 
              placeholder="" 
              label="Dealer Cost" 
              v-model="product.DealerCost"/>
          </div>

					<div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Customer Cost" 
              v-model="product.CustomerCost"/>

						<CurrencyInput 
              class="col" 
              placeholder="" 
              label="Max Price" 
              v-model="product.MaximumPrice"/>
          </div>

					<div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Min Price" 
              v-model="product.MinimumPrice"/>

							<div class="col"></div>
          </div>
          
					<div class="row mb-2">
						<button type="button" class="col btn btn-primary"  style="margin-top: 15px;" @click="saveProduct">Save</button>
					</div>

				</div>
      </div>
</template>

<script>
import { BasicTextInput } from '.';
export default {
  name: 'EditProductForm',
  props:{
    value:{
      type: Object,
      default: () => {
        //fill in customerdetails
      }
    },
		title: {
			type: String,
			default: 'Edit Product'
		}
  },
  data(){
    return{
      product: this.value
    }
  },
  methods: {
    saveProduct(){
      let newProductPrices = this.getNewProductValues();
			this.$emit('closeProductEdit', newProductPrices)
			return;
    },
    getNewProductValues(){
      let newValues = {
        Id: this.product.Id,
        Retail: this.product.Retail?.toFixed(2) ?? 0,
        DealerCost: this.product.DealerCost?.toFixed(2) ?? (0).toFixed(2),
        CustomerCost: this.product.CustomerCost?.toFixed(2) ?? (0).toFixed(2),
        MaximumPrice: this.product.MaximumPrice?.toFixed(2) ?? (0).toFixed(2),
        MinimumPrice: this.product.MinimumPrice?.toFixed(2) ?? (0).toFixed(2),
				PartNumber: this.product.PartNumber,
				ReferenceCode: this.product.ReferenceCode,
				StockCode: this.product.StockCode,
				Description: this.product.Description,
				MfgCode: this.product.MfgCode
      }

      return newValues
    },
  },
}

</script>

<style lang="scss" scoped>
  .card{ 
    width: 550px;
    padding: 25px;
    .modal-card {
      background-color: white;
    }
  }
</style>